import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InfoCardService } from "@tylertech/info-card-module";
import { IInfoCardData } from "@tylertech/tyler-api-types";

export interface ViewOnlyInfoCardDialogData
{
    readonly cardProviderId: string;
    readonly itemId: string;
}

// TODO - this shouldn't live here....
@Component({
    selector: "view-only-info-card-dialog-component",
    templateUrl: "./viewOnlyInfoCardDialog.tmpl.html",
    standalone: false
})
export class ViewOnlyInfoCardDialogComponent implements OnInit
{
    item: IInfoCardData;
    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: ViewOnlyInfoCardDialogData,
        private readonly $infoCardService: InfoCardService
    )
    { }

    get cardProviderId(): string { return this.data.cardProviderId; }
    get itemId(): string { return this.data.itemId; }

    ngOnInit(): void
    {
        this.$infoCardService.Get({
            Id: this.itemId,
            CardProviderId: this.cardProviderId,
            Criteria: undefined,
        })
            .then(
                (item: IInfoCardData) =>
                {
                    this.item = item;
                },
                error =>
                {
                    console.error(error);
                });
    }
}
